import React from 'react';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { Icon } from '@iconify/react';

const PRESETS = [
  {
    value: 'always',
    label: 'Always',
    icon: 'mdi:clock-check',
    description: '24/7 access, all days',
    color: '#4caf50'
  },
  {
    value: 'never',
    label: 'Never',
    icon: 'mdi:clock-remove',
    description: 'No access allowed',
    color: '#f44336'
  },
  {
    value: 'weekdays',
    label: 'Weekdays',
    icon: 'mdi:calendar-week',
    description: 'Mon-Fri, 6am-6pm',
    color: '#2196f3'
  },
  {
    value: 'business',
    label: 'Business',
    icon: 'mdi:briefcase-clock',
    description: 'Mon-Fri, 9am-5pm',
    color: '#ff9800'
  },
  {
    value: 'custom',
    label: 'Custom',
    icon: 'mdi:calendar-edit',
    description: 'Define your own schedule',
    color: '#9c27b0'
  }
];

export default function SchedulePresets({ value, onChange }) {
  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Quick Presets
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        aria-label="schedule preset"
        size="small"
        sx={{ 
          flexWrap: 'wrap',
          '& .MuiToggleButton-root': {
            px: 1.5,
            py: 1,
          }
        }}
      >
        {PRESETS.map((preset) => (
          <Tooltip key={preset.value} title={preset.description} arrow>
            <ToggleButton 
              value={preset.value}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: `${preset.color}20`,
                  borderColor: preset.color,
                  color: preset.color,
                  '&:hover': {
                    backgroundColor: `${preset.color}30`,
                  }
                }
              }}
            >
              <Icon icon={preset.icon} width={18} style={{ marginRight: 4 }} />
              {preset.label}
            </ToggleButton>
          </Tooltip>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}

